<script setup lang="ts">
import SupplierDataTable from "@/components/supplier/SupplierDataTable.vue";

const { t } = useI18n();

definePage({
  alias: "/warehouse/suppliers",
});
</script>

<template>
  <div class="supplier-list-page d-flex flex-column gap-6">
    <div class="supplier-list-page__header">
      <div>
        <div class="text-overline text-primary font-weight-bold">
          {{ t("alkokh.supplierHub.eyebrow") }}
        </div>
        <h1 class="text-h4 font-weight-bold mt-1">
          {{ t("alkokh.supplierHub.listTitle") }}
        </h1>
        <div class="text-body-2 text-medium-emphasis mt-1">
          {{ t("alkokh.supplierHub.listSubtitle") }}
        </div>
      </div>

      <VBtn
        color="secondary"
        variant="tonal"
        prepend-icon="tabler-file-invoice"
        to="/warehouse/purchase-invoices"
      >
        {{ t("alkokh.supplierHub.actions.purchaseInvoices") }}
      </VBtn>
    </div>

    <SupplierDataTable />
  </div>
</template>

<style scoped>
.supplier-list-page {
  background: transparent;
}

.supplier-list-page__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}
</style>
